import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import ImageUploader from '../components/createnft/ImageUploader';
import { useAccount } from 'wagmi';
import { useToasts } from 'react-toast-notifications';
import { api } from '../helper/api';
import { useDispatch, useSelector } from 'react-redux';
import { DEFAULT_IMAGES, IPFS_URL } from '../helper/constant';
import { IPFStoURL, getCurrentChain, getWeb3, uploadFileIPFS, uploadMetadataToIPFS } from '../helper/functions';
import { addLoader, removeLoader } from '../redux/slices/UserSlice';
import { CHAIN_INFO, SUPPORTED_CHAIN } from '../helper/constant';
import nft721Abi from '../abis/nft721.json';
import nft1155Abi from '../abis/nft1155.json';
import { useCommonStats } from '../stats/useCreateNFT';
import { getContract } from '../helper/contractHelper';
import { ethers } from 'ethers';
import { useEthersSigner } from '../stats/useEthersSigner';
import { useNavigate } from 'react-router-dom';


export default function CreateNFT() {
    const [file, setFile] = useState(null);
    const [collectionId, setCollectionId] = useState('');
    const [collectionData, setCollectionData] = useState([]);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [supply, setSupply] = useState('');
    const [royalties, setRoyalties] = useState('');
    const { address, chainId } = useAccount();
    const { addToast, removeAllToasts } = useToasts();
    const userProfile = useSelector((state) => state.user.profile);
    const [type, setType] = useState(null);
    const dispatch = useDispatch()
    const stats = useCommonStats(collectionId, type);
    const signer = useEthersSigner(getCurrentChain(chainId))
    const [attributes, setAttributes] = useState([
        { trait_type: '', value: '' }
    ]);
    const navigate = useNavigate()



    useEffect(() => {
        let getType = collectionId && collectionData && collectionData.filter((items) => items.nft_address === collectionId);
        if (getType && getType[0]) {
            setType(getType[0].type)
        }
        else {
            setType('ERC-1155')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [collectionId]);


    const handleChange = (index, key, value) => {
        const newAttributes = [...attributes];
        newAttributes[index][key] = value;
        setAttributes(newAttributes);
    };

    const addField = () => {
        setAttributes([...attributes, { trait_type: '', value: '' }]);
    };

    const removeField = (index) => {
        const newAttributes = [...attributes];
        newAttributes.splice(index, 1);
        setAttributes(newAttributes);
    };


    useEffect(() => {
        const fetchCollection = async () => {
            try {
                const response = await api.get('collection/get', {
                    params: {
                        owner: address,
                        status: 1
                    }

                });
                if (response && response.data && response.data.error === 'OK') {
                    console.log(response.data)
                    setCollectionData(response.data.data);
                }
                else {
                    addToast(response.data.error, { appearance: 'error', });
                }
            } catch (error) {
                console.error('Error fetching collection:', error);
            }
        };
        if (address) {
            fetchCollection();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [address]);


    const handleCreate = async () => {
        try {
            if (!name || !description || supply <= 0 || !file) {
                dispatch(removeLoader())
                addToast('name ,symbol,image and total supply must required', { appearance: 'error', });
                return false;
            }
            dispatch(addLoader());
            if (address) {
                if (chainId && SUPPORTED_CHAIN.includes(chainId)) {
                    let ipfsHash = await uploadFileIPFS(file);
                    if (ipfsHash.error !== 'OK') {
                        dispatch(removeLoader())
                        addToast(ipfsHash.error, { appearance: 'error', });
                        return false;
                    }

                    let metadata = {
                        name,
                        image: "ipfs://" + ipfsHash.ipfs,
                        description,
                        attributes: attributes
                    }

                    let uploadMetadata = await uploadMetadataToIPFS(metadata);
                    if (!uploadMetadata || uploadMetadata.error !== 'OK') {
                        dispatch(removeLoader())
                        addToast(uploadMetadata.error, { appearance: 'error', });
                        return false;
                    }

                    let nftContract = getContract(type === 'ERC-1155' ? nft1155Abi : nft721Abi, collectionId, signer);
                    let tx;
                    let arags = type === 'ERC-1155' ? [address, supply, `${IPFS_URL}${uploadMetadata.ipfs}`, parseInt(royalties * 100).toString()] : [supply, `${IPFS_URL}${uploadMetadata.ipfs}`, parseInt(royalties * 100).toString()]
                    if (address && address.toLowerCase() === stats.owner.toLowerCase()) {
                        tx = await nftContract.safeMint(
                            ...arags,
                            { 'from': address });
                    }
                    else {
                        tx = await nftContract.mint(
                            ...arags,
                            { 'from': address, value: ethers.utils.parseEther(parseFloat(stats.price * supply).toString()) });
                    }

                    var interval = setInterval(async function () {
                        let web3 = getWeb3(getCurrentChain(chainId));
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                addToast('Transaction completed successfully.', { appearance: 'success', });
                                dispatch(removeLoader());
                                navigate('/my-profile')
                            }
                            else if (response.status === false) {
                                addToast('error ! Your last transaction is failed.', { appearance: 'error', });
                                dispatch(removeLoader());
                            }
                            else {
                                addToast('error ! something went wrong.', { appearance: 'error', });
                                dispatch(removeLoader());
                            }
                        }
                    }, 5000);

                } else {
                    dispatch(removeLoader());
                    removeAllToasts();
                    addToast('Please switch chain to Base mainnet', { appearance: 'error' });
                }
            } else {
                dispatch(removeLoader());
                removeAllToasts();
                addToast('Please connect wallet', { appearance: 'error' });
            }
        } catch (err) {
            dispatch(removeLoader());
            removeAllToasts();
            addToast(err.reason ? err.reason : err.message, { appearance: 'error' });
            console.error(err.message);
        }
    };

    return (
        <Layout>
            <section class="mt-0 mt-md-5">
                <div class="center-y relative text-center">
                    <div class="container">
                        <div class="row">

                            <div class="col-md-12 text-center">
                                <h1>Create an NFT</h1>
                            </div>
                            <p>Once your item is minted you will not be able to change any of its information.</p>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='pt-0' aria-label="section">
                <div class="container">
                    <div class="row wow fadeIn">
                        <div class="col-lg-7 offset-lg-1">
                            <form id="form-create-item" class="form-border" method="post" action="email.php">
                                <div class="field-set">
                                    <h5>Choose collection</h5>
                                    <p class="p-info">This is the collection where your item will appear.</p>

                                    <select onChange={(e) => setCollectionId(e.target.value)} class="form-select" aria-label="Default select example">
                                        <option selected disabled>Select Option</option>
                                        <option selected={CHAIN_INFO[getCurrentChain(chainId)]["default_nft"] === collectionId} value={CHAIN_INFO[getCurrentChain(chainId)]["default_nft"]}>BlockStar NFT(BSTNFT)</option>
                                        {collectionData && collectionData.map((items, key) => {
                                            return (
                                                <option selected={items.nft_address === collectionId} key={key} value={items.nft_address}>
                                                    {items.name}{" "}({items.symbol})
                                                </option>
                                            )
                                        })}
                                    </select>

                                    <div class="spacer-20"></div>

                                    <h5>Name</h5>
                                    <input type="text" value={name} onChange={(e) => setName(e.target.value)} name="item_title" id="item_title" class="form-control" placeholder="e.g. 'Crypto Funk'" />

                                    <div class="spacer-20"></div>

                                    <h5>Description</h5>
                                    <textarea rows="5" onChange={(e) => setDescription(e.target.value)} name="item_desc" class="form-control" placeholder="e.g. 'This is very limited item'">{description}</textarea>

                                    <div class="spacer-20"></div>
                                    <div className='row'>
                                        <div className='col-12 col-md-6'>
                                            <h5>Supply</h5>
                                            <input value={supply} onChange={(e) => setSupply(e.target.value)} type="text" name="supply" id="supply" class="form-control" placeholder="" />
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <h5>Royalties(%)</h5>
                                            <input value={royalties} onChange={(e) => setRoyalties(e.target.value)} type="text" name="item_royalties" id="item_royalties" class="form-control" placeholder="" />
                                        </div>
                                        <div class="spacer-20"></div>
                                        <h5>Traits</h5>
                                        <p>Traits describe attributes of your item. They appear as filters inside your collection page and are also listed out inside your item page.</p>

                                        {attributes.map((attr, index) => (
                                            <div className='row d-flex align-items-center' key={index}>
                                                <div key={index} className='col-4'>
                                                    <label htmlFor={`trait_type_${index}`}>Type</label>
                                                    <input
                                                        type="text"
                                                        id={`trait_type_${index}`}
                                                        placeholder="Enter trait type"
                                                        value={attr.trait_type}
                                                        className='form-control'
                                                        onChange={(e) => handleChange(index, 'trait_type', e.target.value)}
                                                    />
                                                </div>
                                                <div key={index} className='col-4'>
                                                    <label htmlFor={`value_${index}`}>Value</label>
                                                    <input
                                                        type="text"
                                                        id={`value_${index}`}
                                                        placeholder="Enter value"
                                                        value={attr.value}
                                                        className='form-control'
                                                        onChange={(e) => handleChange(index, 'value', e.target.value)}
                                                    />
                                                </div>
                                                <div className='col-4 mt-md-4'>
                                                    
                                                    {index === 0 ? (
                                                        <button className='btn-main' type="button" onClick={() => addField(index)}>
                                                            <i class="fa fa-fw" aria-hidden="true" title="Copy to use plus-square"></i>
                                                        </button>
                                                    ) : (
                                                        <button className='btn-main' type="button" onClick={() => removeField(index)}>
                                                            <i class="fa fa-fw" aria-hidden="true" title="Copy to use remove"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div class="spacer-single"></div>
                                    <p>Estimated Cost : {stats.price && collectionId.toLowerCase() === CHAIN_INFO[getCurrentChain(chainId)].default_nft.toLowerCase() ? stats.price : 0} {CHAIN_INFO[getCurrentChain(chainId)].symbol}</p>
                                    <div className='d-flex justify-content-end'>
                                        <button onClick={() => handleCreate()} type="button" class="btn-main">
                                            Create NFT
                                        </button>
                                    </div>
                                    <div class="spacer-single"></div>
                                </div>
                            </form>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-xs-12">
                            <h5>Preview item</h5>
                            <div class="nft__item">
                                <div class="author_list_pp">
                                    <a href="#sec">
                                        <img class="lazy" src={userProfile ? IPFStoURL(userProfile) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} alt="profile" />
                                        <i class="fa fa-check"></i>
                                    </a>
                                </div>
                                <ImageUploader file={file} setFile={setFile} />
                                <div class="nft__item_info">
                                    <a href="#sec">
                                        <h4>{name}</h4>
                                    </a>
                                    <div class="nft__item_click">
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}
